import axios from "axios";

export const KonicaAPI = axios.create({
	baseURL: window.REACT_APP_ROUTER_BASENAME,
	responseType: "json",
	headers: {
		"Content-Type": "application/json",
		"X-Requested-With": "XMLHttpRequest",
	},
});


KonicaAPI.interceptors.response.use((response) => {
	// Check if response contains a redirect value
	if (response.data.redirect) {
		// Do something with the redirect value, e.g. redirect to the new URL
		window.location.href = window.REACT_APP_BASE_URL + response.data.redirectURL;
	}
	// Return the response object to continue processing it
	return response;
}, (error) => {
	// Handle errors here
	return Promise.reject(error);
});

export const compressLogs = () => {
	try {
		const response = KonicaAPI.post(
			'/log/compress',
			'',
		)
		return (response);
	} catch (error) {
		return (error)
	}
}